import { Component, inject } from '@angular/core';
// Directive for scroll animations
import { ScrollAnimateDirective } from '../../directives/scroll-animate.directive';
// Service for handling navigation to contact form
import { NavigationService } from '../../Services/navigation.service';

@Component({
  selector: 'app-about-us',
  imports: [ScrollAnimateDirective],
  templateUrl: './about-us.html',
  styleUrl: './about-us.scss',
})
export class AboutUs {
  // Injected navigation service for smooth scrolling to contact form
  private navigationService = inject(NavigationService);

  features = [
    {
      icon: '✅',
      title: 'Licensed Carpentry Contractor (NSW)',
      description: 'Licence No: 468652C',
    },
    {
      icon: '✅',
      title: 'Fully Insured',
      description: '$15M Public Liability coverage',
    },
    {
      icon: '✅',
      title: 'White Card Certified',
      description: 'Construction industry White Card credential',
    },
  ];

  // Navigates to contact form when "GET IN TOUCH" button is clicked
  async navigateToContact(): Promise<void> {
    await this.navigationService.navigateToContactForm();
  }
}
